
import { useState } from 'react';
import { performSecurityChecks } from '@/services/security/orderSecurityService';
import { useToast } from '@/hooks/use-toast';

interface UseOrderSecurityReturn {
  isSecurityChecking: boolean;
  performOrderSecurity: (tableId: string, storeId: string) => Promise<boolean>;
}

export function useOrderSecurity(): UseOrderSecurityReturn {
  const [isSecurityChecking, setIsSecurityChecking] = useState(false);
  const { toast } = useToast();

  const performOrderSecurity = async (tableId: string, storeId: string): Promise<boolean> => {
    setIsSecurityChecking(true);
    
    try {
      const securityResult = await performSecurityChecks(tableId, storeId);
      
      if (!securityResult.success) {
        toast({
          title: "Order Blocked",
          description: securityResult.error,
          variant: "destructive",
          duration: 5000,
        });
        return false;
      }

      return true;
    } catch (error) {
      console.error('Security check error:', error);
      toast({
        title: "Security Check Failed",
        description: "Unable to verify order security. Please try again.",
        variant: "destructive",
      });
      return false;
    } finally {
      setIsSecurityChecking(false);
    }
  };

  return {
    isSecurityChecking,
    performOrderSecurity
  };
}
